/* eslint-disable */
//设置cookie
export const setCookie = (cname, cvalue, d, domain) => {
  if (d === -1) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 10000)
    if (domain) {
      var expire = new Date((new Date()).getTime() + 365 * 24 * 60 * 60000);
      expire = ";expires=" + expire.toGMTString();
      // document.cookie = cname + "=logout;expires=" + exp.toGMTString() + "; path=/; domain=sspai.com;"
      document.cookie = cname + "=logout;expires=" + expire + "; path=/; domain=sspai.com;"
    } else {
      document.cookie = cname + "=" + '' + ";expires=" + exp.toGMTString() + "; path=/;"
    }
  } else {
    var expire = new Date((new Date()).getTime() + 365 * 24 * 60 * 60000);
    expire = ";expires=" + expire.toGMTString();
    if (domain) {
      document.cookie = cname + "=" + cvalue + ";expires=" + expire + "; path=/; domain=sspai.com;"
    } else {
      document.cookie = cname + "=" + cvalue + ";expires=" + expire + "; path=/;"
    }
  }
}
//获取cookie
export const getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split('; ');
  for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return "";
}
//清除cookie
export const clearCookie = (name, domain) => {
  setCookie(name, "", -1, domain);
}
